import { Capacitor } from '@capacitor/core';
import { Network } from '@capacitor/network';

export const isNetworkAvailable = (status: { connectionType: string }) =>
	status.connectionType !== 'unknown' && status.connectionType !== 'none';

export const getConnectionStatus = async () => {
	if (import.meta.server) return true;

	if (Capacitor.isNativePlatform()) {
		try {
			const status = await Network.getStatus();
			return isNetworkAvailable(status);
		} catch (error) {
			console.error('Failed to get native network status:', error);
		}
	}

	return navigator.onLine;
};
